import { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "Store/hooks";

import getGitTree from "../thunk/getGitTree.thunk";
import { GetGitTreeParam } from "../types";

const useGetGitTree = (param: GetGitTreeParam) => {
  const gitTree = useAppSelector(
    state => state.git?.tree?.[param?.commitId || ""] || {}
  );
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getGitTree(param));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param.commitId]);
  return gitTree;
};

export default useGetGitTree;
